import type { FraisDTO } from '@/features/api/extranet/dto/Demande/shared'
import type { DateRange } from '@/features/api/extranet/dto/shared'
import { TypesContextesAutorisesEnum, type TypeContextCourant } from '@/features/auth/context-app'
import { isNullUndefinedOrEmptyString, toISODateOnlyString } from '@/features/shared/tools'
import { Sexe } from '../../types/opco'

export function isAdherentOuMandatGestion(typeContext: TypeContextCourant, sousMandat: boolean | null | undefined): boolean {
  return (
    typeContext === TypesContextesAutorisesEnum.Adherent ||
    (typeContext === TypesContextesAutorisesEnum.Prestataire && sousMandat === true)
  )
}

export function checkNir(nir: string): boolean {
  return nir.match(
    '((^([1-2])([0-9]{2})(0[1-9]|[2-35-9][0-9]|[14][0-2])((0[1-9]|[1-9][0-9]|2[abAB])(00[1-9]|0[1-9][0-9]|[1-8][0-9]{2}|9[0-8][0-9]|990)|(9[78][0-9])(0[1-9]|[1-8][0-9]|90))(00[1-9]|0[1-9][0-9]|[1-9][0-9]{2})([0-9]?)([0-9]?)$)|(^([3-47-8])([0-9]{12})([0-9]?)([0-9]?)$))',
  )
    ? true
    : false
}

export function checkNirTemporaire(nir: string): boolean {
  return nir.match('^[\\w]{11,40}$') ? true : false
}

export function checkNirSexe(nir: string, sexe: Sexe): boolean {
  if (!checkNir(nir)) return true

  let sexeValue = '1'
  if (sexe === 'Homme') sexeValue = '1'

  if (sexe === 'Femme') sexeValue = '2'

  const sexeNir = nir.substring(0, 1)
  return sexeValue === sexeNir
}

export function checkNirDateNaissance(nir: string, dateNaissance: Date): boolean {
  if (!checkNir(nir)) return true

  const yearNir = nir.substring(1, 3)
  const monthNir = Number(nir.substring(3, 5))

  if (dateNaissance.getFullYear().toString().substring(2, 4) !== yearNir) return false

  if (monthNir <= 12) {
    if (dateNaissance.getMonth() + 1 !== monthNir) {
      return false
    }
  }

  return true
}

export function checkNirDepartement(nir: string, departement: string): boolean {
  if (!checkNir(nir)) return true

  const nbCaractere = 2
  const indexEnd = 7
  departement = departement.padStart(nbCaractere, '0').toUpperCase()
  let departementNir = nir.substring(5, indexEnd).toUpperCase()

  if (isDrom(departement)) {
    // Cas particulier de Mayotte
    if (departementNir === '98' && departement === '976') departementNir = '97'
    departement = departement.substring(0, 2)
  }

  return departement === departementNir
}

export function isDrom(departement: string): boolean {
  if (isNullUndefinedOrEmptyString(departement)) return false

  return departement.startsWith('97') || departement.startsWith('98')
}

export function getRangeDate(dateDebut: Date | null, dateFin: Date | null): DateRange {
  const dateRange: DateRange = { start: toISODateOnlyString(dateDebut), end: toISODateOnlyString(dateFin) }

  return dateRange
}

export function sumMontantFrais(listeFrais: FraisDTO[]): number {
  return (
    listeFrais.reduce((total, frais) => {
      if (typeof frais.montant !== 'number') return total

      if (frais.baseCalcul === 'Quantite') {
        if (typeof frais.quantite === 'number') {
          total += frais.montant * frais.quantite * 100
        }
      } else {
        total += frais.montant * 100
      }

      return total
    }, 0) / 100
  )
}

export function calculSalaire(tauxHoraireBrut: number, tauxCharge: number, dureeFormation: number): number {
  return dureeFormation * tauxHoraireBrut * (1 + tauxCharge)
}
